import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import AddReclamationForm from './AddReclamationForm';

const styles = theme => ({
    noScrollable: {
        overflowY: 'hidden'
    },
    dialogPaper: {
        maxHeight: '90vh'
    }
});

class AddReclamationDialog extends React.Component {
    handleClose = () => {
        const { onClose } = this.props;

        onClose();
    }

    render() {
        const { reclamationLiee, reclamationParentId, onClose, navigate, infosLogistique } = this.props;

        return (
            <AddReclamationForm
                reclamationLiee={reclamationLiee}
                reclamationParentId={reclamationParentId}
                infosLogistique={infosLogistique}
                onClose={onClose}
                navigate={navigate}
            />
        );
    }
}

AddReclamationDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    reclamationLiee: PropTypes.bool.isRequired,
    reclamationParentId: PropTypes.number.isRequired
};

export default withStyles(styles)(AddReclamationDialog);


